export const MIME_TYPE_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const MIME_TYPE_CSV = 'text/csv';

export enum ExportType {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export const EXTERNAL_LOGIN_NOTICE_KEY = 'externalLoginNotice-';